import z from 'zod/v4';
import { Currency, Entity } from '../index.js';
export var PropertyDataType;
(function (PropertyDataType) {
    PropertyDataType["checkbox"] = "checkbox";
    PropertyDataType["datePicker"] = "date-picker";
    PropertyDataType["dropdown"] = "dropdown";
    PropertyDataType["singleLineText"] = "single-line-text";
    PropertyDataType["multiLineText"] = "multi-line-text";
    PropertyDataType["number"] = "number";
    PropertyDataType["file"] = "file";
    PropertyDataType["address"] = "address";
    PropertyDataType["money"] = "money";
})(PropertyDataType || (PropertyDataType = {}));
export const PropertyRefSchema = z.enum([
    Entity.Case,
    Entity.CaseVoucher,
    Entity.Creditor,
]);
export var ValidatedPropertyHandles;
(function (ValidatedPropertyHandles) {
    ValidatedPropertyHandles["email"] = "email";
    ValidatedPropertyHandles["name"] = "name";
    ValidatedPropertyHandles["phone"] = "phone";
})(ValidatedPropertyHandles || (ValidatedPropertyHandles = {}));
export const AddressSchema = z.object({
    address: z.string(),
    coAddress: z.string().nullish(),
    zipcode: z.string(),
    city: z.string(),
    country: z.string().nullish(),
    door: z.string().nullish(),
    floor: z.string().nullish(),
    houseNoFrom: z.number().nullish(),
    level: z.string().nullish(),
    formatted: z.string().nullish(),
    addressTwo: z.string().nullish(),
    street: z.string().nullish(),
    dawsId: z.string().nullish(),
    text: z.string().nullish(),
    longitiude: z.number().nullish(),
    latitude: z.number().nullish(),
});
export const DataScheme = z.union([
    z.object({
        type: z.literal(PropertyDataType.checkbox),
        data: z.boolean().nullish(),
    }),
    z.object({
        type: z.union([
            z.literal(PropertyDataType.singleLineText),
            z.literal(PropertyDataType.multiLineText),
            z.literal(PropertyDataType.dropdown),
        ]),
        data: z.string().nullish(),
    }),
    z.object({
        type: z.literal(PropertyDataType.number),
        data: z.number().nullish(),
    }),
    z.object({
        type: z.literal(PropertyDataType.datePicker),
        data: z.string().nullish(),
    }),
    z.object({
        type: z.literal(PropertyDataType.address),
        data: AddressSchema,
    }),
    z.object({
        type: z.literal(PropertyDataType.money),
        data: z
            .object({
            amount: z.number().int(),
            currency: z.string(),
        })
            .nullish(),
    }),
    z.object({
        type: z.literal(PropertyDataType.file),
        data: z
            .object({
            fileId: z.string(),
            contentType: z.string(),
            fileName: z.string(),
        })
            .nullish(),
    }),
]);
export const PropertySchema = z
    .object({
    ref: z.union([
        z.literal(Entity.Case),
        z.literal(Entity.CaseVoucher),
        z.literal(Entity.Creditor),
        z.literal(Entity.Collector),
    ]),
    refId: z.uuid(),
    handle: z.string(),
})
    .and(DataScheme);
export const AddPropertyWithoutRefSchema = z
    .object({
    handle: z.string(),
})
    .and(DataScheme);
export const PropertyDataSchema = z
    .union([
    z.string(),
    z.number(),
    z.boolean(),
    z.object({
        amount: z.number(),
        currency: z.enum(Currency),
    }),
    z.object({
        fileId: z.string(),
        contentType: z.string(),
        fileName: z.string(),
    }),
    AddressSchema,
])
    .nullable();
export const OldPropertiesSchema = z.object({
    handle: z.string(),
    data: z.union([
        z.object({
            text: z.string(),
        }),
        z.object({
            value: z.string(),
        }),
        z.object({
            date: z.string(),
        }),
        z.object({
            amount: z.number(),
            currency: z.enum(Currency),
        }),
        z.object({
            checked: z.boolean(),
        }),
    ]),
});
export const normalizePropertiesInput = (properties) => {
    if (Array.isArray(properties)) {
        return properties.reduce((acc, property) => {
            if (!property) {
                return acc;
            }
            if (typeof property.data?.text !== 'undefined') {
                acc[property.handle] = property.data?.text;
            }
            else if (typeof property.data?.number !== 'undefined') {
                acc[property.handle] = property.data?.number;
            }
            else if (typeof property.data?.value !== 'undefined') {
                acc[property.handle] = property.data?.value;
            }
            else if (typeof property.data?.date !== 'undefined') {
                acc[property.handle] = property.data?.date;
            }
            else if (typeof property.data?.checked !== 'undefined') {
                acc[property.handle] = property.data?.checked;
            }
            else {
                acc[property.handle] = property.data;
            }
            return acc;
        }, {});
    }
    else {
        return properties;
    }
};
export const addRefIdToProperties = (properties, ref, refId) => properties.map((property) => ({
    ...property,
    refId: refId,
    ref: ref,
}));
export const listToObject = (properties) => {
    return properties.reduce((acc, property) => {
        acc[property.handle] = property.data;
        return acc;
    }, {});
};
export const filterPropertyTypes = (propertyTypes, ref, scope, scopeId) => propertyTypes.filter((type) => {
    if (type.ref !== ref) {
        return false;
    }
    if (!type.scopeId) {
        return true;
    }
    if (scopeId &&
        scope &&
        type.scopeId &&
        type.scopeId === scopeId &&
        type.scope === scope) {
        return true;
    }
    return false;
});
//# sourceMappingURL=index.js.map